import { onSelectAll } from './dom'

const onInitObserver = (
  selector,
  callbackFunc = null,
  options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  }
) => {
  if (callbackFunc === null) return

  let nodes = []

  if (Array.isArray(selector)) {
    selector.forEach((nodeSelector) => {
      // instance of HTML
      if (nodeSelector instanceof HTMLElement) nodes.push(nodeSelector)
      // array of Nodes
      else if (NodeList.prototype.isPrototypeOf(nodeSelector)) {
        nodeSelector.forEach((subNodes) => {
          if (subNodes instanceof HTMLElement) nodes.push(subNodes)
          else nodes.push(onSelectAll(subNodes))
        })
      }
      // string of selectors
      else nodes.push(onSelectAll(nodeSelector))
    })
  } else if (NodeList.prototype.isPrototypeOf(selector)) {
    selector.forEach((subNodes) => {
      if (subNodes instanceof HTMLElement) nodes.push(subNodes)
      else nodes.push(onSelectAll(subNodes))
    })
  } else {
    // instance of HTML
    if (selector instanceof HTMLElement) nodes.push(selector)
    // string of selectors
    else nodes.push(onSelectAll(selector))
  }

  if (nodes === null) return

  try {
    let intObserver = new IntersectionObserver(callbackFunc, options)

    nodes.forEach((node) => {
      intObserver.observe(node)
    })
  } catch (error) {
    console.error(
      `ERROR: Error in the creation of the 'IntersectionObserver'.
      ${error}`
    )
  }
}

export { onInitObserver }
